import * as actions from './maf-bundle.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ApiMafMethod } from 'src/app/api/api-methods.maf';
import { Injectable, inject } from '@angular/core';
import { MafBundleResponseI } from 'src/app/api/maf-bundle/maf-bundle-result.int';
import { Observable } from 'rxjs';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { loadingMafBundle } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';

@Injectable()
export class ContainerMafBundleEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);


    load$ = createEffect(() =>
        this.actions$.pipe(ofType(actions.load),
            mergeMap((params) => this.sharedGenericService.invoke(ApiMafMethod.mafBundle, params.query).pipe(
                map((data: MafBundleResponseI) =>  {
                  if(!data.error) {
                    return actions.received({
                      data,
                    });
                  }
                }),
                catchError((error: SharedErrorObjectI) => [
                    actions.error({
                        messageText: error.message,
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.messageText,
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => {
            return [
                spxSpinnerActions.hide({
                    action: loadingMafBundle
                })
            ]
        }))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingMafBundle
            }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingMafBundle
            }),
        ]))
    );
}
